import {ATTRIBUTI} from './TabellaAttributiTypes'

export const setAttributi = attributi => {
    return {
        type: ATTRIBUTI,
        load: attributi
    }
}